import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 3v6","key":"svg-0"}],["path",{"d":"M16 16l4 -4l-4 -4","key":"svg-1"}],["path",{"d":"M6 21v-6a3 3 0 0 1 3 -3h11","key":"svg-2"}]]

const IconArrowRampRight3 = createReactComponent('outline', 'arrow-ramp-right-3', 'ArrowRampRight3', __iconNode);

export default IconArrowRampRight3;